export default "__VITE_ASSET__52505137__"